import React from 'react';
import { Zap, Crown } from 'lucide-react';
const URL_BASE = 'https://pagos.digipromarket.com/cart/56260071653702:1';
const URL_UPSELL = 'https://pagos.digipromarket.com/cart/56260096786758:1';
interface CTAButtonProps {
  className?: string;
}
export function CTAButton({
  className = ''
}: CTAButtonProps) {
  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return <div className={`flex flex-col items-center w-full max-w-2xl mx-auto gap-4 ${className}`} data-id="element-77">
      {/* Primary: Upsell offer */}
      <button type="button" onClick={() => handleClick(URL_UPSELL)} className="w-full bg-neon text-black font-extrabold text-lg md:text-2xl py-5 md:py-6 px-4 rounded-xl border-4 border-black animate-pulse-neon hover:bg-[#32e612] transition-colors flex flex-col items-center justify-center gap-2 relative overflow-hidden cursor-pointer" data-id="element-78">
        <div className="absolute top-0 right-0 bg-black text-neon text-xs font-black px-3 py-1 rounded-bl-lg flex items-center gap-1" data-id="element-79">
          <Crown className="w-3 h-3" data-id="element-80" />
          MEJOR OFERTA
        </div>
        <div className="flex items-center gap-2 text-center mt-2" data-id="element-81">
          <Zap className="w-6 h-6 md:w-8 md:h-8 fill-black shrink-0" data-id="element-82" />
          <span data-id="element-83">MÉTODO 500€ + PACK ACELERADOR PRO</span>
        </div>
        <span className="text-2xl md:text-3xl font-black" data-id="element-84">24.99€</span>
        <span className="text-xs md:text-sm font-bold opacity-80" data-id="element-85">
          👇 ACCESO INMEDIATO — TODO INCLUIDO
        </span>
      </button>

      {/* Secondary: Base offer */}
      <button type="button" onClick={() => handleClick(URL_BASE)} className="w-full bg-white text-black font-bold text-base md:text-lg py-4 px-4 rounded-xl border-2 border-gray-300 hover:border-neon hover:shadow-neon transition-all flex flex-col items-center justify-center gap-1 cursor-pointer" data-id="element-86">
        <div className="flex items-center gap-2 text-center" data-id="element-87">
          <Zap className="w-5 h-5 fill-black shrink-0" data-id="element-88" />
          <span data-id="element-89">
            Solo El Método 500€ —{' '}
            <span className="font-black text-xl" data-id="element-90">17.99€</span>
          </span>
        </div>
        <span className="text-xs text-gray-500" data-id="element-91">Sin Pack Acelerador Pro</span>
      </button>

      <p className="text-xs text-gray-400 italic text-center" data-id="element-92">
        Acceso instantáneo. Sin suscripción. Sin letra pequeña.
      </p>
    </div>;
}